import React, {useEffect, useRef, useState} from "react";
import backicon from "../image/backicon.svg";
import {Navigate, useLocation, useNavigate} from "react-router-dom";
import {useContext} from "react";
import {UseContext} from "../context";

import "./Scroll.css";
import Loadingcom from "./allcomponent/Loading";
import axios from "axios";
import {url} from "../url";
import { getSocket, SOCKET_EVENTS } from "../socket";
import GetTime from "./allcomponent/GetTime";
import { toJalaliDate } from "../utils/date";
import Loading from "./allcomponent/Loading";
import {IoMdSend} from "react-icons/io";
import PendingApprovalScreen from "./allcomponent/PendingApproval";

const Messagecom = () => {


    const navigate = useNavigate();
    const location = useLocation();
    const data = location.state;

    const refMessageScroller = useRef(null);



    const [allmessage, setAllmesssage] = useState([]);


    const {setShowmessagecom, getmyprof, getprofloading} =
        useContext(UseContext);


    const [driverMessage, setDriverMessage] = useState("")
    const [refreshData, setRefreshData] = useState(false)

    const [loadingSendMessage, setLoadingSendMessage] = useState(false)


    const handleclosemessagecom = () => {
        navigate(-1);
        setShowmessagecom(false);
    };


    function Getallmessage() {
        axios
            .get(`${url}/travel-message/v1/get-driver-messages-active`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            })
            .then((res) => {
                if (res.status === 200) {
                    setAllmesssage(res.data?.data);
                }
            })
            .catch((error) => {

            });
    }

    useEffect(() => {
        Getallmessage();
    }, [refreshData]);

    // --- WebSocket: با رسیدن پیام جدید، لیست چت خودکار به‌روز می‌شود ---
    useEffect(() => {
        const socket = getSocket();
        if (!socket) return;

        const onNewMessage = () => setRefreshData(prev => !prev);
        socket.on(SOCKET_EVENTS.TRAVEL_MESSAGE_CREATED, onNewMessage);

        return () => {
            socket.off(SOCKET_EVENTS.TRAVEL_MESSAGE_CREATED, onNewMessage);
        };
    }, []);


    useEffect(() => {
        if (allmessage?.length > 4) {
            const scroller = refMessageScroller.current?.closest("#Messagediv");
            scroller?.scrollTo({top: scroller.scrollHeight, behavior: "smooth"});
        }
    }, [allmessage]);


    const finalSendMessage = () => {
        setLoadingSendMessage(true)
        axios.post(`${url}/travel-message/v1/driver-send-message`,
            {
                message: driverMessage,
                travel_id: data._id
            },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`
                }
            }).then(res => {
            setLoadingSendMessage(false)
            setRefreshData(!refreshData);
            setDriverMessage("")
        }).catch(err => {
            setLoadingSendMessage(false)
        })
    }

    console.log(allmessage);
    return (
        <>
            {localStorage.getItem("token") !== null ? (
                <>
                    {data !== null ? (
                        <>
                            {getprofloading === false ? (
                                <>
                                    {getmyprof.status === "profile_not_completed" ? (
                                        <Navigate to="/UserandCarinformation"/>
                                    ) : (
                                        <>
                                            {getmyprof.status === "pending" ? (
                                                <div
                                                    className="w-full flex flex-col h-full  overflow-auto mb-[100px] lg:mb-[88px]">
                                                    <PendingApprovalScreen />
                                                </div>
                                            ) : (
                                                <div className="mk-support-chat-page w-full h-full flex flex-col items-center relative">
                                                    <div id="messagediv" className="w-full col-span-1">
                                                        <div
                                                            className="pr-7 mt-4 cursor-pointer"
                                                            onClick={handleclosemessagecom}
                                                        >
                                                            <img alt="" src={backicon}></img>
                                                        </div>

                                                        <div
                                                            className="text-[16px] text-black flex-col flex gap-2 justify-center items-center mt-4">
                                                            <span>{data.passenger_snapshot.full_name}</span>
                                                            <p className="text-[16px] xxl:text-[20px] px-7 font-medium text-lightgraytext text-center ">
                                                                اینجا می توانید به مسافر پیام بفرستید یا پیام
                                                                های مسافر را دریافت کنید.
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div
                                                        className="flex flex-col mb-24 h-full overflow-auto w-full gap-y-4 p-5"
                                                        id="Messagediv"
                                                    >
                                                        {allmessage.map((item, index) => {
                                                            return (
                                                                <div key={index} id='ui-chat'
                                                                     className={`w-full flex flex-col ${item?.sender?.passenger ? `items-end` : `items-start`}`}>

                                                                    <div
                                                                        className={!item?.sender?.passenger ? "bg-slate-300 w-[30%] rounded-[20px] rounded-tr-none p-2" : "hidden"}>
                                                                        {/* اسم و پیام */}
                                                                        <div className="flex flex-col  p-2">
                                                                            {/*<p className="text-[16px]">شما</p>*/}
                                                                            <p className="mt-1">
                                                                                {item.sender.driver && item.message}
                                                                            </p>
                                                                        </div>
                                                                        {/* تاریخ */}
                                                                        <p className="text-[12px] text-end mr-2">{toJalaliDate(item.createdAt)}</p>
                                                                    </div>

                                                                    {/* ادمین  */}
                                                                    <div
                                                                        className={item?.sender?.passenger ? `bg-blue-300 w-[30%] rounded-[20px] rounded-tl-none p-2 ` : `hidden`}>
                                                                        {/* اسم و پیام */}
                                                                        <div className="flex flex-col  p-2">
                                                                            {/*<p className="text-[20px] ">مسافر</p>*/}
                                                                            <p className="mt-1">
                                                                                {
                                                                                    !item.sender.driver && item.message
                                                                                }
                                                                            </p>
                                                                        </div>

                                                                        {/* تاریخ */}
                                                                        <p className="text-[12px] text-end mr-2">
                                                                            <GetTime time={item.createdAt}/></p>

                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                        <div ref={refMessageScroller}></div>
                                                    </div>
                                                    <div
                                                        className="mk-chat-composer flex justify-center items-center w-full bottom-0 absolute bg-white rounded-xl">
                                                        <div
                                                            className={`flex w-[90%] bg-white mt-2  mb-[24px] gap-x-5 border-2 border-slate-400 rounded-xl px-2`}>
                                                            <button disabled={loadingSendMessage === true}
                                                                    onClick={finalSendMessage}
                                                                    className="text-[25px] flex-grow cursor-pointer">
                                                                {loadingSendMessage ?
                                                                    <Loading/>
                                                                    :
                                                                    <IoMdSend
                                                                    />
                                                                }

                                                            </button>
                                                            <input value={driverMessage}
                                                                   onChange={(e) => setDriverMessage(e.target.value)}
                                                                   className="py-5 rounded-xl border-none outline-none w-full"
                                                                   placeholder="پیام خود را بنویسید..."/>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </>
                            ) : (
                                <div className=" h-full w-full flex flex-col   items-center justify-center ">
                                    <>
                                        <div
                                            id="traveldiv"
                                            className=" flex  items-center justify-center  "
                                        >
                                            <p className="text-[20px] text-center  text-[black] font-bold">
                                                در انتظار دریافت اطلاعات ...
                                            </p>
                                        </div>
                                    </>
                                </div>
                            )}
                        </>
                    ) : (
                        <Navigate to="/report"/>
                    )}
                </>
            ) : (
                <Navigate to="/"/>
            )}
        </>
    );
};
export default Messagecom;
